import { formatDateValue, normalizeText } from "./workbook";

export function asKpiLabel(value) {
  if (value === true) return "YES";
  if (value === false) return "NO";
  return "";
}

function buildReconciledRecord(baseRecord) {
  return {
    ...baseRecord,
    carrierDespatchDate: baseRecord.carrierDespatchDate,
    kpiHit: baseRecord.carrierKpiHit,
    carrierEta: baseRecord.carrierEta,
    carrierCompletedDate: baseRecord.carrierCompletedDate,
    reconciledDespatchDate:
      baseRecord.carrierDespatchDate || baseRecord.machshipDespatchDate || "",
    reconciledEta: baseRecord.carrierEta || baseRecord.machshipEta || "",
    reconciledCompletedDate:
      baseRecord.carrierCompletedDate || baseRecord.machshipCompletedDate || "",
    reconciledKpiExplanation:
      baseRecord.userUpdatedKpiExplanation ||
      baseRecord.carrierKpiExplanation ||
      baseRecord.automatedKpiExplanation ||
      "",
    etaPrioritySource: baseRecord.carrierEta ? "Carrier Data" : "Machship Data",
    despatchPrioritySource: baseRecord.carrierDespatchDate
      ? "Carrier Data"
      : "Machship Data",
    completedPrioritySource: baseRecord.carrierCompletedDate
      ? "Carrier Data"
      : "Machship Data",
    explanationPrioritySource: baseRecord.userUpdatedKpiExplanation
      ? "User Input"
      : baseRecord.carrierKpiExplanation
      ? "Carrier Data"
      : baseRecord.automatedKpiExplanation
      ? "Automated Logic"
      : "",
  };
}

export function createBaseRecord({
  carrier,
  sourceSheet,
  rowNumber,
  consignmentId,
  despatchDate,
  eta,
  completedDate,
  automatedKpiHit,
  automatedKpiExplanation = "",
  carrierKpiExplanation = "",
  ruleApplied,
  rawStatus = "",
  forceMajeureReason = "",
  exclusionCategory = "",
  exclusionDescription = "",
}) {
  return buildReconciledRecord({
    sourceCarrier: carrier,
    sourceSheet,
    sourceRowNumber: rowNumber,
    consignmentId: normalizeText(consignmentId),
    machshipDespatchDate: "",
    carrierDespatchDate: formatDateValue(despatchDate),
    userUpdatedDespatchDate: "",
    machshipEta: "",
    carrierEta: formatDateValue(eta),
    userUpdatedEta: "",
    machshipCompletedDate: "",
    carrierCompletedDate: formatDateValue(completedDate),
    userUpdatedCompletedDate: "",
    automatedKpiHit,
    automatedKpiExplanation,
    carrierKpiHit: automatedKpiHit,
    carrierKpiExplanation,
    userUpdatedKpiExplanation: "",
    rawStatus: normalizeText(rawStatus),
    forceMajeureReason: normalizeText(forceMajeureReason),
    exclusionCategory: normalizeText(exclusionCategory),
    exclusionDescription: normalizeText(exclusionDescription),
    ruleApplied,
    processedAt: new Date().toISOString(),
    processedBy: "Carrier DIFOT Integration",
    isProcessed: true,
  });
}
